export default __webpack_public_path__ + "static/app-thumbnail-46ef49601109d2ece95f954806fa31c9.jpg";